import { render, staticRenderFns } from "./Accessory.vue?vue&type=template&id=0be79da0&scoped=true"
import script from "./Accessory.vue?vue&type=script&lang=js"
export * from "./Accessory.vue?vue&type=script&lang=js"
import style0 from "./Accessory.vue?vue&type=style&index=0&id=0be79da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be79da0",
  null
  
)

export default component.exports